import MainHeading from "../../typeComponents/MainHeading";
import TextBlock from "../../typeComponents/TextBlock";
import Paragraph from "../../typeComponents/Paragraph";
import { Box } from "@mui/material";
import CureLogoCleanVector from "../../images/CURE_logo_clean_vector.svg";

const Grantwriting = () => {
  return (
    <TextBlock>
      <MainHeading>Get Money for Projects!</MainHeading>
      <Box sx={{ width: { xs: "45vw", md: "24vw" }, padding: "10px" }}>
        <img src={CureLogoCleanVector} alt="CURE Montreal Logo" />
      </Box>
      <Paragraph>
        Hiya, below are the slides that we use in our workshops! We're working
        on making a more web-friendly version that will hopefully be up soon!
      </Paragraph>
      <img
        src="https://i.ibb.co/LDMGXH7Y/Get-money-4-project-12.jpg"
        alt="Get-money-4-project-12"
        border="0"
      />
      <img
        src="https://i.ibb.co/tPBKfZrW/Get-money-4-project-2.jpg"
        alt="Get-money-4-project-2"
        border="0"
      />
      <img
        src="https://i.ibb.co/DgDQbnj5/Get-money-4-project-3.jpg"
        alt="Get-money-4-project-3"
        border="0"
      />
      <img
        src="https://i.ibb.co/RpVN8dGw/Get-money-4-project-4.jpg"
        alt="Get-money-4-project-4"
        border="0"
      />
      <img
        src="https://i.ibb.co/1fhbk8jt/Get-money-4-project-5.jpg"
        alt="Get-money-4-project-5"
        border="0"
      />
      <Paragraph>
        List of on-campus grants{" "}
        <a href="https://docs.google.com/document/d/1neJgeZavnK1JNzXoXQthgaiyOYZ1SGjeSYzQy6un5AU/edit?tab=t.0">
          here!
        </a>
      </Paragraph>
      <img
        src="https://i.ibb.co/hx4sDdbx/Get-money-4-project-6.jpg"
        alt="Get-money-4-project-6"
        border="0"
      />
      <img
        src="https://i.ibb.co/Wv2rjvZ7/Get-money-4-project-7.jpg"
        alt="Get-money-4-project-7"
        border="0"
      />
      <img
        src="https://i.ibb.co/7NZwpd51/Get-money-4-project-8.jpg"
        alt="Get-money-4-project-8"
        border="0"
      />
      <img
        src="https://i.ibb.co/6JRqNpZ4/Get-money-4-project-9.jpg"
        alt="Get-money-4-project-9"
        border="0"
      />
      <img
        src="https://i.ibb.co/fVHsc608/Get-money-4-project-10.jpg"
        alt="Get-money-4-project-10"
        border="0"
      />
      <img
        src="https://i.ibb.co/d4J14HLg/Get-money-4-project-11.jpg"
        alt="Get-money-4-project-11"
        border="0"
      />
    </TextBlock>
  );
};

export default Grantwriting;
